import { render, staticRenderFns } from "./chooser.vue?vue&type=template&id=21f6af76&"
import script from "./chooser.vue?vue&type=script&lang=js&"
export * from "./chooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports